<template>
  <div id="app">
    <router-view class="router-view"></router-view>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";

export default {
  name: "App",
  components: {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  background-color: #f6f8f9;
  /* max-width: 1440px; */
  margin: 0 auto;
}

body {
  background-color: #000;
  width: 100%;
  height: 100%;
  margin: 0;
}

html {
  font-size: 62.5% !important; /* 10÷16=62.5% */
  font-family: PingFangSC-Semibold, PingFang SC;
  /* font-weight: 600; */
  color: #1d1d1f;
}
@media only screen and (min-width: 481px) {
  html {
    font-size: 94% !important; /* 15.04÷16=94% */
  }
}
@media only screen and (min-width: 561px) {
  html {
    font-size: 109% !important; /* 17.44÷16=109% */
  }
}
@media only screen and (min-width: 641px) {
  html {
    font-size: 125% !important; /* 20÷16=125% */
  }
}
@media only screen and (min-width: 320px) {
  html {
    font-size: 62.5% !important;
  }
}
@media only screen and (min-width: 360px) {
  html {
    font-size: 72.5% !important;
  }
}
@media only screen and (min-width: 400px) {
  html {
    font-size: 82.5% !important;
  }
}
@media only screen and (min-width: 480px) {
  html {
    font-size: 94% !important;
  }
}
</style>
